import React, { useState } from "react";
import ViewTable from "../../../components/Common/ViewTable";
import { connect } from "react-redux";
import Switch from "react-switch"
import { useEffect } from "react";
import CustomisedModal from "../../../components/Modal/CustomisedModal";
import InquiryStatus from "./InquiryStatus";
import { addEditLinkManagementRequest, changeLinkStatusRequest, getLinkManagementRequest } from "../../../redux/admin/linkManagement/action";
import AddEditLink from "./AddEditLink";
import { commonConfirmBox } from "../../../helper/messagehelpers";
import { EditSvg } from "../../../components/CommonSvg";

function LinkManagementList(props) {
  const { LinkList, totalRecords, getLinkManagementRequest, addEditLinkManagementRequest, changeLinkStatusRequest } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [searchData, setSearchData] = useState("");
  console.log(searchData, "searchDatasearchData")
  const [modalView, setModaleView] = useState(false);
  const [cahngeStatusId, setCahngeStatusId] = useState(null);
  const [isEdit, setIsEdit] = useState(null)
  const handleModalToggle = () => {
    setModaleView(!modalView);
  };
  const dispatchData = {
    searchText: searchData,
    pagination: {
      limit: dataPerPage,
      page: currentPage,
      orderKey: "createdDate",
      orderBy: "ASC",
    },
  };

  const columns = [
    {
      dataField: "title",
      text: "Title",
      sort: true,
    },
    {
      dataField: "url",
      text: "Url",
      sort: true,
      formatter: (cell, row) => <span
        className="text-nowrap"
        style={{
          width: "30rem",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "block",
        }}
      >
        <a href={row.url} target="_blank" rel="noopener noreferrer">{row.url}</a></span>,
    },
    {
      dataField: "visibleTo",
      headerClasses: "text-center",
      text: "Visible To",
      sort: true,
      formatter: (cell, row) => (<div className="text-center">
        {row.visibleTo === "members_only" ? <span>Member Portal</span> : <span>Admin Portal</span>}
      </div>)
    },

    {
      dataField: "openNewTab",
      headerClasses: "text-center",
      text: "Open New Tab",
      sort: true,
      formatter: (cell, row) => (<div className="text-center">
        {row.openNewTab ? <span>Yes</span> : <span>No</span>}
      </div>)
    },
    {
      dataField: "isActive",
      text: "Status",
      headerClasses: "text-center",
      classes: "text-center",
      sort: true,
      formatter: (cell, row) => {
        return (
          <>
            <div
              className="text-center"
              onClick={(e) => {
                if (e && e.stopPropagation) {
                  e.stopPropagation();
                }

              }}
            >
              <Switch
                className={`react-switch justify-content-center switch-sm ${row.isActive && "isActive"}`}
                onChange={async (e) => {
                  if (e && e.stopPropagation) {
                    e.stopPropagation();
                  }
                  const response = await commonConfirmBox(!row.isActive ? "Do you want to activate this link?" : "Do you want to deactivate this link?");
                  if (response) {
                    changeLinkStatusRequest({
                      status: {
                        id: row.id,
                        status: !row.isActive,
                      },
                      dispatchData,
                    });
                  }
                }}
              type="checkbox"
              id="custom-switch"
              checked={row.isActive}
              />
            </div>

          </>

        );
      },
    }, {
      dataField: "Action",
      text: "",
      headerClasses: "action_col",
      formatter: (cell, row) => (
        <div className="action_col text-center">
          <button
            className="my-tooltip btn btn-link edit_btn"
            data-tooltip-content={"Edit"}
            onClick={(e) => {
              if (e && e.stopPropagation) {
                e.stopPropagation();
              }
              setIsEdit(row)
              setModaleView(!modalView);
              // handleEditModalToggle(row);
            }}
          >
            <EditSvg />
          </button>
        </div>
      ),
    },
  ];
  useEffect(() => {
    getLinkManagementRequest(dispatchData);
  }, [dataPerPage, currentPage, searchData]);

  return (
    <>
      <ViewTable
        data={LinkList?.length > 0 ? LinkList : []}
        columns={columns}
        dataPerPage={dataPerPage}
        currentPage={currentPage}
        setDataPerPage={setDataPerPage}
        setCurrentPage={setCurrentPage}
        pagination={true}
        totalRecords={totalRecords}
        Header={true}
        // rowClassName={"cursor-pointer"}
        setSearchData={setSearchData}
        updateData={() =>
          getLinkManagementRequest({
            searchText: "",
            pagination: {
              limit: dataPerPage,
              page: 1,
              orderKey: "createdDate",
              orderBy: "ASC",
            },
          })
        }
        addModalData={handleModalToggle}
        buttonNameModal={"Add Link"}
        hedingName="Link Management"
        searchBar={true}
      />

      {modalView && (
        <CustomisedModal
          modalView={modalView}
          modalName={isEdit?.id ?"Edit Link" :"Add Link" }
          onModalDismiss={() => {
            setModaleView(false);
            setIsEdit(null)
          }}
        >
          <AddEditLink
            initialData={{
              title: isEdit?.title ? isEdit.title : "",
              url: isEdit?.url ? isEdit.url : "",
              visibleTo: isEdit?.visibleTo ? isEdit.visibleTo : "members_only",
              openNewTab: isEdit?.openNewTab ? isEdit.openNewTab : false,
              id: isEdit?.id ? isEdit.id : null,
            }}

            addEditLinkManagementRequest={addEditLinkManagementRequest}
            dispatchData={dispatchData}
            onModalDismiss={() => {
              setModaleView(false);
              setIsEdit(null)
            }}
          />

        </CustomisedModal>
      )}
    </>
  );
}
const mapStateToProps = ({ linkReducer }) => {
  console.log(linkReducer.addLink?.status, "linkReducerlinkReducer")
  let LinkList =
    linkReducer.getLinks?.list?.length > 0 ? linkReducer.getLinks.list : [];
  let totalRecords =
    linkReducer.getLinks?.totalRecords &&
    linkReducer.getLinks.totalRecords;
  let linkStatus = linkReducer.addLink?.status ? linkReducer.addLink.status : false
  return {
    LinkList,
    totalRecords, linkStatus
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getLinkManagementRequest: (data) => dispatch(getLinkManagementRequest(data)),
    addEditLinkManagementRequest: (data) => dispatch(addEditLinkManagementRequest(data)),
    changeLinkStatusRequest: (data) => dispatch(changeLinkStatusRequest(data))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LinkManagementList);
